/* tabgroup.control_adapter.js */

var $ = require("jquery");
var _ = require("lodash");
var EventEmitter = require("events").EventEmitter;
var util = require("util");
var q = require("q");

var Conjurer = require("../Conjurer");

/**
 * @event ObjectControlAdapter#ValueChanged
 * @type {Object}
 * @property oldValue {string} The previous value
 * @property newValue {string} The new value
 */

/**
 * @class ObjectControlAdapter
 * @classdesc renders an Object Jtype.
 * @implements ControlAdapterInterface
 *
 * @param $scope {$scope} The $scope object attached to the containingElement
 * @param logger {Bunyan} The logger
 * @param containingElem {DomElement} The containing dom element for this control
 * @param formCtrlDef {FormControlDefinition} The definition of this control object.
 *
 * @requires util
 * @requires EventEmitter
 *
 * @fires ObjectControlAdapter#ValueChanged
 */
module.exports = function TabGroupAdapter(logger, containingElem, formCtrlDef) {
    var self = this;
    var loadDeferred = q.defer();
    var _scope;
    var _compile;
    var tabHeaderArea;
    var overflowTabWidth;
    var tabWidths = [];

    //call Event Emitter Constructor
    EventEmitter.call(this);

    //The name of the control
    this.name = formCtrlDef.name;

    this.tabLabels = [];

    this._addOverflowMenuItem = function (label, tabNumber) {
        if (!_.isEmpty(_scope.overflowTitle)) {
            _scope.overflowTitle += ", ";
        }
        _scope.overflowTitle += label;
        var overflowContent = containingElem.find(".tab_overflow_content." + formCtrlDef.tabName);
        var overflowMenuItem = $(
            '<a ng-click="tabSelected(' +
                tabNumber +
                ');$event.stopPropagation()">' +
                label +
                "</a>"
        );
        overflowContent.append(overflowMenuItem);
    };

    // Function to determine what type of tab layout we are going to have
    this._checkTabWidth = function (apply) {
        var idx = 0;
        _scope.displayOverflowContent = false;
        _scope.overflowTitle = "";
        var currentTabWidth = tabHeaderArea.width();
        // Added for now for debug.
        _scope.currentTabWidth = currentTabWidth;
        // Check if the size of the tab area is less than will fit for all the tabs.
        if (currentTabWidth <= _scope.totalTabHeaderWidth) {
            for (idx = 0; idx < formCtrlDef.tabs.length; idx++) {
                _scope.visibleTabs[idx] = false;
            }
            var overflowContent = containingElem.find(
                ".tab_overflow_content." + formCtrlDef.tabName
            );
            overflowContent.empty();

            _scope.displayOverflowTab = true;

            var visibleTabWidth = overflowTabWidth;

            // Get the current selected tab width
            var currentSelectedIdx = _scope.tabInfo[_scope.tabName].currentTabNum;
            var selectedTabWidth = tabWidths[currentSelectedIdx];
            var selectedVisible = false;
            if (visibleTabWidth + selectedTabWidth < currentTabWidth) {
                _scope.visibleTabs[currentSelectedIdx] = true;
                visibleTabWidth += selectedTabWidth;
                selectedVisible = true;
            } else {
                self.tabLabels.forEach(function (label, idx) {
                    self._addOverflowMenuItem(label, idx);
                });
            }
            var maxReached = false;
            // If we at least have room for the current selected tab.
            if (selectedVisible) {
                for (idx = 0; idx < self.tabLabels.length; idx++) {
                    // Add all except the current selected.
                    if (idx !== currentSelectedIdx) {
                        var currentWidth = tabWidths[idx];
                        if (!maxReached && currentWidth + visibleTabWidth < currentTabWidth) {
                            _scope.visibleTabs[idx] = true;
                            visibleTabWidth += currentWidth;
                        } else {
                            // If the current tab is sooner in the list, then
                            // we have to take into account that the selected tab must show.
                            if (!maxReached) {
                                maxReached = true;
                            }
                            self._addOverflowMenuItem(self.tabLabels[idx], idx);
                        }
                    }
                }
            }
            _scope.visibleTabWidth = visibleTabWidth;
            _compile(overflowContent)(_scope);

            if (apply) {
                _scope.$apply();
            }
        } else {
            _scope.displayOverflowTab = false;
            for (idx = 0; idx < formCtrlDef.tabs.length; idx++) {
                _scope.visibleTabs[idx] = true;
            }
            if (apply) {
                _scope.$apply();
            }
        }
    };

    /**
     * @returns the data associated with this control.
     */
    this.getValue = function () {
        var val = formCtrlDef.value;
        //On initialization the child does not yet exist but thats ok as
        //the valueChanged events will handle this for us.
        if (_scope.ObjectRendererApi && _scope.ObjectRendererApi.getValue) {
            val = _scope.ObjectRendererApi.getValue();
        }
        return val;
    };

    /**
     * Set this controls current value.
     * @param val {string} The value to set this control to.
     * @returns the value associated with this control, it might not always be the same as the value passed in for
     * example adapters with a ValueScope.PARENT.
     */
    this.setValue = function (val, silent = true) {
        _scope.ObjectRendererApi.renderValues(val, silent);
    };

    this.getMultiEditActive = function () {
        return _scope.ObjectRendererApi.getMultiEditActive();
    };

    /**
     * Returns if data on this control is invalid
     * @returns {boolean}
     */
    this.isInvalid = function () {
        return _scope.ObjectRendererApi ? _scope.ObjectRendererApi.isInvalid() : false;
    };

    /**
     * Returns validation messages associated on this control
     * @returns {Array}
     */
    this.getValidationMessages = function () {
        return _scope.ObjectRendererApi ? _scope.ObjectRendererApi.getValidationMessages() : [];
    };
    /**
     * Tear down this control
     */
    this.tearDown = function () {
        _scope.ObjectRendererApi.removeAllListeners();
        _scope.ObjectRendererApi.tearDown();
    };

    /**
     * A Hook to start the angular work, due to timing issues don't try anything angularis before this hook is called.
     * @param $scope
     */
    this.$init = function ($scope, $compile, $timeout, $provide) {
        _scope = $scope;
        _compile = $compile;

        $scope.ObjectRendererSettings = {};

        $scope.tabName = formCtrlDef.tabName;
        $scope.tabInfo = {};
        $scope.tabInfo[$scope.tabName] = {};
        $scope.visibleTabs = [];
        $scope.overflowTitle = "";
        for (var idx = 0; idx < formCtrlDef.tabs.length; idx++) {
            $scope.visibleTabs.push(true);
        }
        // Initialize the tab value
        $scope.tabInfo[$scope.tabName].currentTabNum = 0;

        $scope.tabSelected = function (tabNumber) {
            $scope.displayOverflowContent = false;
            $scope.$root.$broadcast("TabChange", {
                tabName: formCtrlDef.tabName,
                tabNum: tabNumber,
            });
        };

        $scope.showOverflowContent = function () {
            $scope.displayOverflowContent = true;
        };

        var setFocusOnOverflow = function () {
            var overflowContent = $(containingElem).find(
                ".tab_overflow_content." + formCtrlDef.tabName
            );
            overflowContent.focus();
        };

        // When the overflow content is about to be displayed, set the focus on
        // it so that blur will work.
        $scope.$watch("displayOverflowContent", function (newValue, oldValue) {
            if (newValue) {
                $timeout(setFocusOnOverflow);
            }
        });

        $scope.hideOverflowContent = function () {
            $scope.displayOverflowContent = false;
        };

        /**
         * Check if a particular tab should be visible.
         * @param tabNumber
         * @returns {Boolean} true if the tab should be displayed.
         */
        $scope.checkVisibleTab = function (tabNumber) {
            return $scope.visibleTabs[tabNumber];
        };

        // Listen for a tab change on the parent.
        var tabListenerCleanup = $scope.$on("TabChange", function (tabEvent, msg) {
            if ($scope.tabName === msg.tabName) {
                $scope.tabInfo[$scope.tabName].currentTabNum = msg.tabNum;
            }

            // Delay this until the object has had a chance to paint.
            $timeout(self._checkTabWidth);
        });

        var dockletListenerCleanup = $scope.$on("glLmrbLayout.events.resizeDocklets", function () {
            $timeout(function () {
                self._checkTabWidth(true);
            }, 100);
        });

        var configListenerCleanup = $scope.$on("instance.events.config-tab-selected", function () {
            $timeout(function () {
                self._checkTabWidth(true);
            }, 100);
        });

        $scope.$on("$destroy", function () {
            dockletListenerCleanup();
            configListenerCleanup();
        });

        $scope.$on("$destroy", function () {
            tabListenerCleanup();
        });

        var tabFormListener = $scope.$on("TabFormRendered", function (tabEvent, msg) {
            if ($scope.tabName === msg.tabName) {
                // Delay this until the object has had a chance to paint.
                $timeout(self._checkTabWidth);
            }
        });

        $scope.$on("$destroy", function () {
            tabFormListener();
        });

        //Setup directive
        var tabHead = '<div class="rendered_control nested tab_top ' + formCtrlDef.tabName + '">';
        tabHead += '<span class="tab_debug">current available width {{currentTabWidth}}</span>';
        tabHead += '<span class="tab_debug"> tab size {{totalTabHeaderWidth}} </span>';
        tabHead += '<span class="tab_debug"> visible tab width {{visibleTabWidth}} </span>';
        tabHead += '<ul class="rendered_control tab_nav" ng-style="{\'display\':tabDisplay}">';
        var tabNumber = 0;
        var tabClassName = "rendered_control";
        tabClassName += " tab_selector";
        tabClassName += " tab_button " + formCtrlDef.tabName;
        formCtrlDef.tabs.forEach(function (tabForm) {
            var tabClassName = "rendered_control";
            tabClassName += " tab_selector";
            tabClassName += " tab_button " + formCtrlDef.tabName;
            var tab = "<li";

            // start tab attributes
            tab += ' class="' + tabClassName + '"';
            tab += ' ng-click="tabSelected(' + tabNumber + ')"';

            tab += ' ng-class="{active: tabInfo[tabName].currentTabNum == ' + tabNumber + '}"';

            tab += ' ng-show="checkVisibleTab(' + tabNumber + ')"';

            // end tab tag attributes
            tab += ">";

            // Check if the display.label value is set.
            var tabLabel = tabForm.name;
            if (tabForm.configSettings.Display.label) {
                tabLabel = tabForm.configSettings.Display.label;
            } else if (tabForm.configSettings.Display.tab) {
                tabLabel = tabForm.configSettings.Display.tab;
            }
            self.tabLabels.push(tabLabel);
            // tab label
            tab += tabLabel;

            tab += "</li>";
            tabHead += tab;

            tabNumber++;
        });

        // Add the overflow tab
        var overflowClass = tabClassName + " overflowTab";
        tabHead +=
            '<li ng-focus(checkFocus()) title="{{overflowTitle}}" ng-show="displayOverflowTab" ng-click="showOverflowContent()" class="' +
            overflowClass +
            '">';
        tabHead += "</li>";
        tabHead +=
            '<div tabindex="-1" ng-blur="hideOverflowContent()" class="rendered_control tab_overflow_content ' +
            formCtrlDef.tabName +
            '" ng-show="displayOverflowContent">';
        tabHead += '<a class="tab_overflow_selector">test1</a>';
        tabHead += '<a class="tab_overflow_selector">test2</a>';
        tabHead += '<a class="tab_overflow_selector">test3</a>';
        tabHead += "</div>";

        tabHead += "</ul>";
        tabHead += "</div>";
        containingElem.append(tabHead);
        var objectRendererElem = $(
            '<gl-form-renderer class="object_renderer" data-api="ObjectRendererApi" data-settings="ObjectRendererSettings"></gl-form-renderer>'
        );
        containingElem.append(objectRendererElem);

        //Notify the world this adapter is ready to be compiled/linked and values retrieved
        self.emit("InitializationComplete", {
            initializedValue: self.getValue(),
        });
        return loadDeferred.promise;
    };
    /**
     * @type {Array.<String>}
     * @description $inject Annotation By adding the $inject property onto the init function the Angular
     * injection parameters can be specified.
     */
    this.$init.$inject = ["$scope", "$compile", "$timeout"];

    /**
     * A Hook for when this control has been compiled/Linked.
     * @param $scope {$scope} The Angular Scope variable
     *
     * if $compiledAndLinked.$inject is specified those injection parameters will be used as the arguments
     */
    this.$compiledAndLinked = function ($scope) {
        $scope.ObjectRendererApi.on("ValueChanged", function (evt) {
            self.emit("ValueChanged", evt);
        });
        $scope.ObjectRendererApi.on("MultiEditActive", function (evt) {
            self.emit("MultiEditActive", evt);
        });
        $scope.ObjectRendererApi.on("Invalid", function (evt) {
            self.emit("Invalid", evt);
        });
        $scope.ObjectRendererApi.once("AllControlsLoaded", function (evt) {
            loadDeferred.resolve();
        });
        //Render the object
        $scope.ObjectRendererApi.render(formCtrlDef.configSettings.value, {
            configurationData: formCtrlDef.configData,
            refInstances: formCtrlDef.refInstances,
            refTypes: formCtrlDef.refTypes,
            displayModeOptions: formCtrlDef.displayModeOptions,
        });

        // Get all the tab elements and calculate the width of the tabs.
        var tabQuery = "li.tab_button." + formCtrlDef.tabName;
        var tabElements = containingElem.find(tabQuery);
        var marginSize = 10;
        $scope.totalTabHeaderWidth = 0;
        for (var idx = 0; idx < tabElements.length; idx++) {
            var tabElement = tabElements[idx];
            // Huge hack, need to figure out the real margin
            tabWidths[idx] = tabElement.offsetWidth + marginSize;
            $scope.totalTabHeaderWidth += tabWidths[idx];
        }

        overflowTabWidth = 27;

        // Get the width of the div containing the tabs.
        var headerQuery = "div." + formCtrlDef.tabName;
        tabHeaderArea = containingElem.find(headerQuery);

        self._checkTabWidth(true);

        $(window).resize(function () {
            self._checkTabWidth(true);
        });
    };
};
//Make this API inherit from EventEmitter
util.inherits(module.exports, EventEmitter);

//Tell the Form renderer that this is an Angular Control.
module.exports.isAngularControl = true;
